import * as React from 'react';
import classnames from 'classnames';
import { Card } from '@grandvisionhq/common';
import { FormContext } from '../Form/Form.js';

const FormCard = ({ selected , children , className , layout , respondToFormFields  })=>{
    const context = React.useContext(FormContext);
    const hasInvalidFields = React.useMemo(()=>{
        return respondToFormFields.some((fieldName)=>{
            var ref, ref1, ref2, ref3, ref4;
            return ((ref = context.getInitialState) === null || ref === void 0 ? void 0 : ref.call(context, fieldName)) ? !((ref1 = context.getInitialState) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.call(context, fieldName)) === null || ref2 === void 0 ? void 0 : ref2.isValid) && ((ref3 = context.getInitialState) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.call(context, fieldName)) === null || ref4 === void 0 ? void 0 : ref4.isTouched) : false;
        });
    }, [
        respondToFormFields,
        context
    ]);
    return /*#__PURE__*/ React.createElement(Card, {
        layout: layout,
        className: classnames('form-card', className, {
            'form-card--selected': selected,
            'form-card--invalid': hasInvalidFields
        })
    }, children);
};
var FormCard$1 = FormCard;

export { FormCard$1 as default };
//# sourceMappingURL=FormCard.js.map
